import type { FaqContentBlock, FaqEntry } from '@/types/faq'

/**
 * Legacy table data supported by FaqCard's existing presentation logic.
 */
export interface FaqTableData {
  readonly headers: readonly string[];
  readonly rows: readonly (readonly string[])[];
}

/**
 * View-compatible FAQ item backed by the shared FAQ entry model.
 */
export interface FaqItem extends FaqEntry {
  readonly table?: FaqTableData;
}

/**
 * View-compatible FAQ category backed by shared FAQ content.
 */
export interface FaqCategory {
  readonly id: string;
  readonly title: string;
  readonly items: readonly FaqItem[];
}

/**
 * Compatibility alias for FAQ components that consume rich content blocks.
 */
export type ContentBlock = FaqContentBlock

/**
 * Presentation limits used by FaqCard only. Source FAQ data is never truncated.
 */
export const FAQ_CONSTRAINTS = {
  MAX_ANSWER_LENGTH: 500,
  MAX_TABLE_COLUMNS_PC: 5,
  MAX_TABLE_ROWS_PC: 20,
} as const
